import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import Route from '@ember/routing/route';

export default class CoachingCoacheeCohortCoachesShortlistRoute extends Route<CoachingCoacheeCohortModel> {
  model(): CoachingCoacheeCohortModel {
    return this.modelFor(
      'coaching.coachee.cohort.coaches'
    ) as CoachingCoacheeCohortModel;
  }
}
